import { useTranslation } from "react-i18next";
import { FormInput } from "@/shared/Components";
import styles from "./styles.module.scss";

export const TitleInput = () => {
  const { t } = useTranslation();

  return (
    <FormInput
      classNames={{
        input: styles.input,
      }}
      name={"currentNote.title"}
      placeholder={t("notesPage.inputTitle")}
      className={styles.root}
    />
  );
};
